module.exports = __webpack_public_path__ + "img/play.a9253970.svg";